import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
  path: '/memberCenter',
  component: () => import('@/layout/index'),
  redirect: 'memberCenter/carrierManagement',
  meta: {
    title: i18n.t('hui-yuan-zhong-xin'),
    icon: 'icon-huiyuan2',
    perms: ['bee:member']
  },
  children: [
    {
      path: 'carrierManagement',
      component: () => import('@/module/memberCenter/page/operator/manage.vue'),
      meta: {
        title: i18n.t('yun-ying-shang-guan-li'),
        icon: 'icon-yunyingshang1',
        perms: ['bee:member:operator']
      }
    },
    {
      path: 'vip',
      component: () => import('@/module/memberCenter/page/vip/manage.vue'),
      meta: {
        title: i18n.t('vip-guan-li'),
        icon: 'icon-vip',
        perms: ['bee:member:vip']
      }
    },
    {
      path: 'groupManagement',
      component: () => import('@/module/memberCenter/page/group/manage.vue'),
      meta: {
        title: i18n.t('ji-tuan-guan-li'),
        icon: 'icon-jituan1',
        perms: ['bee:member:group']
      }
    },
    {
      path: 'memberManagement',
      component: () => import('@/module/memberCenter/page/customer/manage.vue'),
      meta: {
        title: i18n.t('hui-yuan-guan-li'),
        icon: 'icon-huiyuan',
        perms: ['bee:member:customer']
      }
    },
    {
      path: 'discountManagement',
      component: () => import('@/module/memberCenter/page/discountManagement.vue'),
      meta: {
        title: i18n.t('zhe-kou-guan-li-0'),
        icon: 'icon-huiyuan',
        perms: ['bee:member:discount']
      }
    },
    {
      path: 'walletManagement',
      component: () => import('@/module/memberCenter/page/wallet/manage.vue'),
      meta: {
        title: i18n.t('qian-bao-guan-li'),
        icon: 'icon-jifen2',
        perms: ['bee:member:wallet']
      }
    },
    {
      path: 'rechargeCarmichaelManagement',
      component: () => import('@/module/memberCenter/page/rechargeCarmichael/manage.vue'),
      meta: {
        title: i18n.t('chong-zhi-ka-mi-guan-li'),
        icon: 'icon-jifen2',
        perms: ['bee:member:rechargeCarmichael']
      }
    },
    {
      path: 'rechargeRuleManagement',
      component: () => import('@/module/memberCenter/page/rechargeRule/manage.vue'),
      meta: {
        title: i18n.t('chong-zhi-gui-ze-guan-li'),
        icon: 'icon-jifen2',
        perms: ['bee:member:rechargeRule']
      }
    },
    {
      path: 'cardManagement',
      component: () => import('@/module/cardManage/page/cards/manage.vue'),
      meta: {
        title: i18n.t('ka-hao-guan-li'),
        icon: 'icon-qia2',
        perms: ['bee:member:card']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/memberCenter/router/index.js